module.exports = __webpack_public_path__ + "static/media/walk-in.b24c71ee.svg";